import DisplayIfUserType from "components/utils/DisplayIfUserType/DisplayIfUserType";
import type React from "react";
import TabSwitchButtonGroup from "./TabSwitchButtonGroup";
import type { TabGroupInterfaceProps } from "./model";

const TabGroupInterface = (
  props: TabGroupInterfaceProps,
): React.ReactElement => {
  const liveTab = props.liveTab;
  const content = liveTab?.disabled
    ? liveTab.disabledPlaceholder
    : liveTab?.tabContent;

  return (
    <>
      <TabSwitchButtonGroup {...props} />
      <DisplayIfUserType userTypes={liveTab?.userTypes || "viewer"}>
        {content}
      </DisplayIfUserType>
    </>
  );
};

export default TabGroupInterface;
